export enum TextWidthBasis {
  parent,
  longestLine,
}
